import { RootState } from "RootReducer";

export const getPlanHasProducts = (state: RootState) => Object.values(state.inbound.productDetailsCache).length > 0;
export const getProductDskus = (state: RootState) => Object.keys(state.inbound.productDetailsCache);
